import React, { Component } from 'react'
import { connect } from 'react-redux'
import GameActions from '../../../../actions/game/game-actions'
import './DDDNaughtsAndCrosses_style.css'
import imgA from './assets/winA.png'
import imgB from './assets/winB.png'
import imgC from './assets/winC.png'

// --- new game form component --- //
export function DDDNaughtsAndCrosses_NewForm_CP (props) {
  function render () {
    let pg = <div>3D Tick Tac Toe new game form goes here</div>
    return pg
  }

  return render()
}

// --- rules component --- //
export function DDDNaughtsAndCrosses_Rules_CP (props) {
  function render () {
    let pg = <div className='rules-page'>
      <div className='rules-title'>Three Dimensional Knots and Crosses</div>
      The board is a four by four by four cube. Be the first to get four in a row straight or diagonally across any dimensions.
      <br />
      <br />
      For example all of these are valid wins:
      <br />
      <img src={imgA} className='DDD-rules-img' alt="" />
      <img src={imgB} className='DDD-rules-img' alt="" />
      <img src={imgC} className='DDD-rules-img' alt="" />
    </div>
    return pg
  }

  return render()
}

// --- history component --- //
export function DDDNaughtsAndCrosses_Hist_CP (props) {
  // TODO: implement a proper enforced interface
  // props should be: { moveHistory, playerDict }

  function render() {
    let rows = []
    for (let phaseId=0; phaseId<props.moveHistory.length; phaseId++) {
      let phase = props.moveHistory[phaseId]
      let actionRows = []
      Object.keys(phase).forEach(userId => {
        actionRows.push(renderPlayerRow(userId, phase[userId], phaseId))
      })

      rows.push(
        <div className='move-hist-phase' key={phaseId}>
          {actionRows}
        </div>
      )
    }
    return rows
  }

  function renderPlayerRow(userId, action, phaseId) {
    return (
      <div className='move-hist-action' key={`${phaseId}-${userId}`}>
        <div className='move-hist-action-player-name' style={{color: props.playerDict[userId].color}}>
          {props.playerDict[userId].name}
        </div>
        <div className='move-hist-action-player-move'>
          {
            `${Number(action['MOVE'].z)+1},${Number(action['MOVE'].x)+1},${Number(action['MOVE'].y)+1}`
          }
        </div>
      </div>
    )
  }

  return render()
} 

// --- game component --- //
class DDDNaughtsAndCrosses_CP extends Component {
  constructor() {
    super()
    // this.state = {}
    this.highlightSquares = []
  }

  makeHighlightSquares () {
    // TODO make this a selector
    this.highlightSquares = []
    let finalVals = []
    if (this.props.game?.gameState?.final){
      finalVals = Object.values(this.props.game.gameState.final)
    }
      // highlight the winning
    if (finalVals.length){
      finalVals.forEach(userWin => {
        userWin.forEach(row => {
          row.forEach(square => {
            this.highlightSquares.push(JSON.stringify(square))
          })
        })
      })
    } else if (this.props.game?.gameState?.move_history?.length){
      // highlight most recent
      let lastMoveI = this.props.game.gameState.move_history.length - 1
      let lastMove = Object.values( this.props.game.gameState.move_history[lastMoveI] )[0]['MOVE']
      this.highlightSquares.push(JSON.stringify([String(lastMove.x), String(lastMove.y), String(lastMove.z)]))
    }
  }

  isHighlightSquare (x, y, z) {
    let square = JSON.stringify([String(x), String(y), String(z)])
    for (let i=0; i<this.highlightSquares.length; i++) {
      if (square == this.highlightSquares[i]) return true
    }
    return false
  }

  render() {
    this.makeHighlightSquares()
    let board = []
    for (let z=0; z<4; z++){
      board.push(this.makeZBoard(z))
    }

    return (
      <div className='DDD-main-contain'>
        {board}
      </div>
    )
  }

  makeZBoard (z) {
    const zClassName = `DDD-z${z}`
    let rows = []
    for (let y=0; y<4; y++){
      rows.push(this.makeYBoard(y, z))
    }
    return (
      <div className={zClassName} key={`z${z}`}>
        <div className='DDD-z-content'>
          {rows}
        </div>
      </div>
    )
  }

  makeYBoard (y, z) {
    let cells = []
    for (let x=0; x<4; x++){
      cells.push(this.makeXBoard(x, y, z))
    }
    return (
      <div className='DDD-row' key={`y${y}`}>
        {cells}
      </div>
    )
  }

  makeXBoard (x, y, z) {
    const markO = 1
    const markX = 2
    const cellVal = this.props.game.gameState.current_state.board[x][y][z]
    let className = 'DDD-cell'
    let userIndex = this.props.game.gameState.users.indexOf(this.props.userId)
    if (-1 === userIndex) return null
    let userSymbol = "O"
    if (1 === userIndex) userSymbol = "X"
    let isSelectable = false
    // cellVal: DDD-O, DDD-X, DDD-selectable-${userSymbol}
    // most recent .DDD-last
    if (cellVal === markO) {
      className += ' DDD-O'
    } else if (cellVal === markX) {
      className += ' DDD-X'
    } else if (
      !this.props.game.isSubmitting
      && this.props.game?.gameState?.phase?.actions_by_user
      && this.props.userId in this.props.game.gameState.phase.actions_by_user
    ) {
      className += ` DDD-selectable-${userSymbol}`
      // and do onclick
      isSelectable = true
    }
    
    if (this.isHighlightSquare(x, y, z)){
      className += ` DDD-last`
    }

    return (
      <div 
        className={className} 
        key={`x${x}`}
        onClick={isSelectable ? event => this.onSubmitMove(x, y, z, event) : undefined}
      ></div>
    )
  }

  onSubmitMove (x, y, z) {
    let action = {
      "MOVE": {x:String(x), y:String(y), z:String(z)},
    }
    this.props.submitMove(action)
  }

}

const mapStateToProps = (state) => {
  return {
    userId: state.user.user.id,
    game: state.game,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    submitMove: (action) => dispatch(GameActions.submitMove(action))
  }
}
  
export default connect(mapStateToProps, mapDispatchToProps)(DDDNaughtsAndCrosses_CP)
